const rules = [
  v => (v !== null && v !== "") || "Es requerido",
  v => v !== "0" || "No puede ser cero",
  v =>
    /^\d+(\.\d{2})?$/.test(v + "") || "Si usas decimales, debe haber 2 dígitos"
];

export default rules;
